import { defineStore } from "pinia";
import * as _debug from "debug";
import ApiClient from "@/lib/ApiClient";
import { sureClone } from "@/lib/DataUtils";
import { createStore } from "./storeHelper";
import _ from "lodash";

const debug = _debug(`${process.env.VUE_APP_PREFIX}:ChecklistRowsStore`);

const DEFAULT_EDITOR = {
  id: null,
  text: null,
  checklistId: null,
  sequenceNumber: null,
};

export const useChecklistRowsStore = defineStore(
  "checklistRows",
  createStore({
    state: {
      checklistRows: {},
      editor: sureClone(DEFAULT_EDITOR),
    },

    getters: {
      checklistRowsList: (state) => _.values(state.checklistRows),
      rowsByChecklist: (state) => (checklistId) => {
        return _.values(state.checklistRows)
          .filter((row) => row.checklistId === checklistId)
          .sort((a, b) => a.sequenceNumber - b.sequenceNumber);
      },
      checklistRowById: (state) => (id) => state.checklistRows[id],
      editorChanges() {
        return this.getEditorChanges("checklistRows");
      },
      editorHasChanges() {
        const diff = this.editorChanges;
        return diff && !_.isEmpty(diff);
      },
    },

    actions: {
      newChecklistRowToEditor() {
        this.set("editor", sureClone(DEFAULT_EDITOR));
      },

      addChecklistRow(row) {
        this.checklistRows[row.id] = row;
      },

      deleteChecklistRow(rowId) {
        delete this.checklistRows[rowId];
      },

      clearChecklistRows() {
        this.checklistRows = {};
      },

      async load() {
        debug("load");
        const rows = await ApiClient.get(`/checklistRows`);
        debug("load", rows);
        this.set("checklistRows", _.keyBy(rows, "id"));
      },

      async loadChecklistRowToEditor(rowId) {
        debug("loadChecklistRowToEditor", rowId);
        const row = this.checklistRows[rowId];
        if (!row) {
          throw new Error("Checklist row not found");
        }
        this.set("editor", sureClone(row));
      },

      async saveChecklistRowInEditor() {
        if (!this.editorHasChanges) {
          debug("saveChecklistRowInEditor", "No changes to save");
          return;
        }

        const rowId = this.editor.id;
        const result = await ApiClient.put(
          `/checklistRows/${rowId}`,
          this.editor,
        );

        if (result) {
          this.addChecklistRow(result);
        }
        return result;
      },
    },
  }),
);
